module.exports = __webpack_public_path__ + "media/svg/flechevideo-white-b50f798d.svg";